import { useState } from "react";
import {
  setTournamentLastLevel,
  setTournamentFirstLevel,
  setTournamentLevel,
  updateTimer,
} from "../../../../../api/tournament-timer";
import { controlLevel } from "../../../hooks/timer";
import { useControllerContext } from "../../../hooks/controller-context";
import { pubState } from "../../../../../recoil/pub.atom";
import { useRecoilValue } from "recoil";
import { isTournamentAccess } from "../../../../../utils/owner";

export const useTournamentLevel = () => {
  const { data, timeInfo, getData } = useControllerContext();
  const [levelInput, setLevelInput] = useState(0);
  const pub = useRecoilValue(pubState);

  // 마지막 레벨 이동
  const handleLastLevel = async () => {
    if (!data?.timerDto) return;
    if (!isTournamentAccess(data.id, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${data.id}에 대한 권한이 없습니다. `);
      return;
    }
    try {
      await setTournamentLastLevel(data.timerDto.id);
      getData();
    } catch (e: any) {
      console.error(e);
      if (e.status === 403) {
        alert(e.response.data.message);
        return;
      }
      alert(e.message);
    }
  };

  // 첫번째 레벨 이동
  const handleFirstLevel = async () => {
    if (!data?.timerDto) return;
    if (timeInfo.elapsedTimeMs && timeInfo.elapsedTimeMs <= 0) return;
    if (!isTournamentAccess(data.id, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${data.id}에 대한 권한이 없습니다. `);
      return;
    }

    try {
      await setTournamentFirstLevel(data.timerDto.id);
      getData();
    } catch (e: any) {
      console.error(e);
      if (e.status === 403) {
        alert(e.response.data.message);
        return;
      }
      alert(e.message);
    }
  };

  // 레벨 업데이트 (input)
  const handleLevel = async () => {
    if (!data?.timerDto) return;
    if (timeInfo.elapsedTimeMs && timeInfo.elapsedTimeMs <= 0) return;
    if (levelInput <= 0) {
      alert("0이하의 레벨로 설정할 수 없습니다. ");
      return;
    }
    if (!isTournamentAccess(data.id, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${data.id}에 대한 권한이 없습니다. `);
      return;
    }

    const resultLevel = data.structure.find(
      (item) => item.level === levelInput,
    );
    if (!resultLevel || !resultLevel.id) {
      alert("존재하지 않는 레벨입니다. ");
      return;
    }

    try {
      await setTournamentLevel(data.timerDto.id, resultLevel?.id);
      getData();
      setLevelInput(0);
    } catch (e: any) {
      console.error(e);
      if (e.status === 403) {
        alert(e.response.data.message);
        return;
      }
      alert(e.message);
    }
  };

  // 레벨 업데이트(+1, -1)
  const handleUpdateLevel = async (value: number) => {
    if (
      !data?.structure ||
      !timeInfo.currentLevel ||
      !data.timerDto ||
      (timeInfo.elapsedTimeMs && timeInfo.elapsedTimeMs < 0)
    )
      return;
    if (!isTournamentAccess(data.id, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${data.id}에 대한 권한이 없습니다. `);
      return;
    }
    const playTime = controlLevel(
      value,
      data?.structure,
      timeInfo.currentLevel,
    );
    if (playTime === value) return;
    let type;
    const nowLevel =
      timeInfo.currentLevel.type === "BREAK"
        ? `BREAK(LV.${data.structure[timeInfo.currentLevel.ord - 2]?.level})`
        : `LV.${timeInfo.currentLevel.level}`;
    const nextLevel =
      data.structure[timeInfo.currentLevel.ord]?.type === "BREAK"
        ? "BREAK"
        : `LV.${data.structure[timeInfo.currentLevel.ord]?.level}`;
    const beforeLevel =
      data.structure[timeInfo.currentLevel.ord - 2]?.type === "BREAK"
        ? `BREAK(LV.${data.structure[timeInfo.currentLevel.ord - 3]?.level})`
        : `LV.${data.structure[timeInfo.currentLevel.ord - 2]?.level}`;
    if (value > 0) {
      type = `레벨 업 ${nowLevel} -> ${nextLevel}`;
    } else {
      type = `레벨 다운 ${nowLevel} -> ${beforeLevel}`;
    }
    try {
      await updateTimer(data.timerDto?.id, playTime, undefined, type);
      getData();
    } catch (e: any) {
      if (e.status === 403) {
        alert(e.response.data.message);
        return;
      }
      alert(e.message);
    }
  };

  // 현재 레벨
  const getLevelText = () => {
    if (
      (data?.isEnd === false && !data.timerDto) ||
      (timeInfo.elapsedTimeMs && timeInfo.elapsedTimeMs < 0)
    ) {
      return "시작 준비 중";
    }
    if (timeInfo.currentLevel?.level) {
      return "LV " + timeInfo.currentLevel?.level;
    }
    return "BREAK";
  };

  return {
    levelInput,
    setLevelInput,
    handleFirstLevel,
    handleLastLevel,
    handleLevel,
    handleUpdateLevel,
    getLevelText,
  };
};
